// extracted by mini-css-extract-plugin
module.exports = {"show_tag_user":"_1ylpIyqRPv","check-span":"_2UFIXfHXlI","edit":"_1YT0HBzDH_"};